import { HttpInterceptorFn } from '@angular/common/http';
import { retry } from 'rxjs/operators';

export const retryInterceptor: HttpInterceptorFn = (_req, next) =>
  next(_req).pipe(retry({ count: 2 }));
